import Box from "@mui/material/Box"
import CircularProgress, { circularProgressClasses, CircularProgressProps } from "@mui/material/CircularProgress"

export default function StyledCircularProgress(props: CircularProgressProps) {
  return (
    <Box sx={{ position: "relative", lineHeight: 0 }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) => theme.palette.gray["9"]
        }}
        size={20}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: (theme) => theme.palette.gray["13"],
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round"
          }
        }}
        size={20}
        thickness={4}
        {...props}
      />
    </Box>
  )
}
